import { useEffect, useRef, useState } from "react";
import {
  AdvanceCustomizationType,
  AdvertisingDetailsType,
} from "../types/data_types";
import "swiper/css";
import "swiper/css/zoom";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./styles/BhpTrendsSection.css";
import {
  convertImgJsonToObj,
  fetchImgThumbnailData,
  getParamsFromSearchString,
} from "../common/commonFunctions";
import { IonButton, IonCol, IonGrid, IonIcon, IonRow } from "@ionic/react";
import { pencil } from "ionicons/icons";
import { bhpEditLinks, getPageType } from "../types/constants";
import {
  useAppSelector,
  useRecordUserInteractions,
  userActionsTable,
} from "../app/hooks";
import { useHistory, useLocation } from "react-router";
import { BusinessDetailsType } from "../pages/BussinessHomePage";
import { mobileWidthBreakpoint } from "../types/form_table_data_types";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay, EffectCoverflow, Swiper as SwiperClass } from "swiper";

// const BhpTrendsExpandImgSlider: React.FC<{
//   adData: AdvertisingDetailsType;
//   activeIdx: number;
//   idx: number;
// }> = (props) => {
//   const [imgData, setImgData] = useState("");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const getImg = async () => {
//       console.log("Called get img ", props.activeIdx, props.idx);
//       try {
//         setLoading(true);
//         const imgObj = convertImgJsonToObj(props.adData.bgImg.imgName);
//         if (!imgData) {
//           const imgData = await fetchImgThumbnailData(
//             imgObj.fileName,
//             false,
//             100,
//             true
//           );
//           setImgData(imgData);
//         }
//         setLoading(false);
//       } catch (e) {
//         setLoading(false);
//       }
//     };
//     if (props.idx === props.activeIdx) {
//       getImg();
//     }
//   }, [props.activeIdx, props.idx]);
//   return (
//     <>
//       {!loading && <img src={imgData} alt="Certificate" loading="lazy" />}
//       {loading && <IonSpinner color={"light"} />}
//     </>
//   );
// };

const BhpTrendsElement: React.FC<{
  adData: AdvertisingDetailsType;
  idx: number;
  onClick: () => void;
  editMode: boolean;
  pageId?: string | number;
  advanceCustomization: AdvanceCustomizationType;
}> = (props) => {
  const [imgData, setImgData] = useState("");
  const [imgCss, setImgCss] = useState("");
  const history = useHistory();

  useEffect(() => {
    const getImg = async () => {
      try {
        //console.log("image name ", props.adData);
        const imgObj = convertImgJsonToObj(props.adData.bgImg.imgName);
        setImgCss(imgObj.imgCss);

        const imgData = await fetchImgThumbnailData(
          imgObj.fileName,
          undefined,
          80
        );
        setImgData(imgData);
      } catch (e) {
        console.log(e);
      }
    };
    if (
      !!props.adData?.bgImg?.imgName &&
      typeof props.adData.bgImg.imgName === "string"
    ) {
      getImg();
    }
  }, [props.adData]);

  const getTitle = () => {
    const stringLimit = 40;
    if (!props?.adData?.title) return "";
    return props.adData.title.length > stringLimit
      ? props.adData.title.substring(0, stringLimit) + "..."
      : props.adData.title;
  };

  const getShopName = () => {
    const stringLimit = 25;
    if (!props?.adData?.shopName) return "";
    return props.adData.shopName.length > stringLimit
      ? props.adData.shopName.substring(0, stringLimit) + "..."
      : props.adData.shopName;
  };

  const isMobile =
    useAppSelector((state) => state.screenWidth).width < mobileWidthBreakpoint;

  return (
    <div
      className="bhp-trends-card"
      style={{
        boxShadow: !isMobile && "0 3px 10px rgba(0, 0, 0, 0.2)",
      }}
    >
      <div onClick={props.onClick}>
        <div className={`bhp-trends-el-top`}>
          <img
            src={imgData}
            alt=""
            className="bhp-trends-el-top-img"
            loading="lazy"
          />
          <div className="bhp-trends-el-shop-det">{getShopName()}</div>
          {/* <div className="bhp-trends-el-stats">
            <div>
              <IonIcon icon={heart} />
              <span style={{ paddingLeft: "2px" }}>1232</span>
            </div>
            <div>
              <IonIcon icon={trendingUp} />
              <span style={{ paddingLeft: "2px" }}>71232</span>
            </div>
          </div> */}
        </div>
        <div className="bhp-trends-el-text">
          <div>{getTitle()}</div>
        </div>
      </div>
      <div
        className={`bhp-trends-button ${
          !!props?.adData?.couponMode ? "bhp-trends-button-coupon" : ""
        }`}
        onClick={props.onClick}
        style={{
          backgroundColor: props.advanceCustomization?.accentColor || "",
          color: props.advanceCustomization?.accentColorContrast || "",
        }}
      >
        {!!props?.adData?.couponMode ? "Get Coupon" : "View Details"}
      </div>
      {!!props.editMode && (
        <IonButton
          fill="solid"
          size="small"
          color="tertiary"
          onClick={() => {
            history.push(
              bhpEditLinks.editOffer
                .replace("%offerId%", `${props.adData.id}`)
                .replace("%SCHOOL_ID%", `${props.pageId}`)
            );
          }}
        >
          <IonIcon icon={pencil} />
        </IonButton>
      )}
    </div>
  );
};

const BhpTrendsSection: React.FC<{
  adData: AdvertisingDetailsType[];
  gridMode?: boolean;
  editMode: boolean;
  pageId?: string | number;
  recordUserInteraction?: boolean;
  pageSection?: "MAIN" | "TREND_ALL";
  openTrendsExpand: (id: string | number) => void;
  bussinessDetailsDB: BusinessDetailsType;
  advanceCustomization: AdvanceCustomizationType;
}> = (props) => {
  // const [openTrendsIdx, setOpenTrendsIdx] = useState<number>(-1);
  // const [openTrendsExpand, closeTrendsExpand] = useModalController(
  //   "expand",
  //   setOpenTrendsIdx,
  //   () => {
  //     setOpenTrendsIdx(-1);
  //   }
  // );
  // const recordAction = useRecordUserInteractions();
  // const currentAd = useMemo(() => {
  //   return openTrendsIdx !== -1 ? props.adData[openTrendsIdx] : undefined;
  // }, [props.adData, openTrendsIdx]);

  // useEffect(() => {
  //   if (!!currentAd) {
  //     if (props.recordUserInteraction) {
  //       recordAction({
  //         action: userActionsTable.expandDetails,
  //         pageId: props.pageId,
  //         pageSection: props.pageSection,
  //         pageType: getPageType(false),
  //         popId: currentAd.id,
  //         popType: "TREND",
  //       });
  //     }
  //   }
  // }, [currentAd]);
  //   const [activeIdx, setActiveIdx] = useState<number>(-1);
  // const openTrendsJsx = (
  //   <IonModal
  //     isOpen={openTrendsIdx !== -1}
  //     onDidDismiss={() => {
  //       closeTrendsExpand();
  //     }}
  //   >
  //     <IonHeader>
  //       <IonToolbar color="dark">
  //         <IonButtons slot="end">
  //           <IonButton
  //             fill="clear"
  //             color={"light"}
  //             onClick={() => {
  //               closeTrendsExpand();
  //             }}
  //           >
  //             <IonIcon icon={close} slot="start" />
  //             Close
  //           </IonButton>
  //         </IonButtons>
  //       </IonToolbar>
  //     </IonHeader>
  //     <IonContent color={"dark"}>
  //       <Swiper
  //         initialSlide={openTrendsIdx}
  //         lazy={true}
  //         modules={[Navigation, Zoom, Pagination]}
  //         navigation={true}
  //         zoom={true}
  //         pagination={{
  //           clickable: true,
  //           dynamicBullets: true,
  //           dynamicMainBullets: 5,
  //         }}
  //         onRealIndexChange={(e) => {
  //           setOpenTrendsIdx(e.activeIndex);
  //         }}
  //       >
  //         {props.adData.map((el, idx) => {
  //           const imgObj = convertImgJsonToObj(el.bgImg.imgName);
  //           return (
  //             <SwiperSlide key={idx}>
  //               <div
  //                 className={imgObj.imgCss}
  //                 style={{
  //                   objectFit: "contain",
  //                   height: "100%",
  //                   width: "100%",
  //                 }}
  //               >
  //                 <div className={`swiper-zoom-container`}>
  //                   <BhpTrendsExpandImgSlider
  //                     adData={el}
  //                     activeIdx={openTrendsIdx}
  //                     idx={idx}
  //                   />
  //                 </div>
  //               </div>
  //             </SwiperSlide>
  //           );
  //         })}
  //       </Swiper>
  //     </IonContent>
  //     <IonFooter>
  //       <IonToolbar color={"dark"}>
  //         {!!currentAd && (
  //           <div style={{ padding: "10px" }}>
  //             <div style={{ fontSize: "1rem", fontWeight: "bold" }}>
  //               {currentAd.title}
  //             </div>
  //             <div style={{ fontSize: "0.8rem", paddingTop: "5px" }}>
  //               {currentAd.shopName}
  //             </div>
  //             <div
  //               style={{
  //                 fontSize: "0.7rem",
  //                 color: "lightgray",
  //                 padding: "5px 0",
  //               }}
  //             >
  //               {currentAd.shopAddress}
  //             </div>
  //             <div style={{ display: "flex" }}>
  //               <div style={{ width: "50%" }}>
  //                 <IonButton
  //                   expand="block"
  //                   color={"light"}
  //                   fill="solid"
  //                   onClick={() => {
  //                     if (props.recordUserInteraction) {
  //                       recordAction({
  //                         action: userActionsTable.whatsapp,
  //                         pageId: props.pageId,
  //                         pageSection: props.pageSection,
  //                         pageType: getPageType(false),
  //                         popId: currentAd.id,
  //                         popType: "TREND",
  //                       });
  //                     }
  //                     whatsappMessage(
  //                       `I saw your promo "${currentAd.title}". I am interested to know more`,
  //                       currentAd.shopPhone
  //                     );
  //                   }}
  //                 >
  //                   <IonIcon icon={logoWhatsapp} />
  //                 </IonButton>
  //               </div>
  //               <div style={{ width: "50%" }}>
  //                 <IonButton
  //                   expand="block"
  //                   color={"light"}
  //                   fill="clear"
  //                   onClick={() => {
  //                     if (props.recordUserInteraction) {
  //                       recordAction({
  //                         action: userActionsTable.visitPage,
  //                         pageId: props.pageId,
  //                         pageSection: props.pageSection,
  //                         pageType: getPageType(false),
  //                         popId: currentAd.id,
  //                         popType: "TREND",
  //                       });
  //                     }
  //                     window.location.assign(
  //                       getSeoUrl(currentAd.seoUrlDetails)
  //                     );
  //                   }}
  //                 >
  //                   <IonIcon icon={openOutline} />
  //                 </IonButton>
  //               </div>
  //             </div>
  //           </div>
  //         )}
  //       </IonToolbar>
  //     </IonFooter>
  //   </IonModal>
  // );
  const recordAction = useRecordUserInteractions();
  const location = useLocation();
  const [couponIdShown, setCouponIdShown] = useState(false);

  useEffect(() => {
    const params = getParamsFromSearchString(location.search);
    if (params.couponId && props.adData && !couponIdShown) {
      const id = parseInt(params.couponId);
      recordAction({
        action: userActionsTable.adScan,
        pageId: props.bussinessDetailsDB.id,
        pageSection: "MAIN",
        pageType: getPageType(
          props.bussinessDetailsDB.isMarket,
          props.bussinessDetailsDB.marketType
        ),
        popId: params.couponId,
        popType: "AD",
      });
      props.openTrendsExpand(id);
      setCouponIdShown(true);
    }
  }, [props.adData]);

  const screenWidth = useAppSelector((state) => state.screenWidth).width;
  const isMobile = screenWidth < mobileWidthBreakpoint;

  const swiperRef = useRef<SwiperClass | null>(null);
  useEffect(() => {
    if (swiperRef.current && props.adData.length > 1) {
      setTimeout(() => {
        swiperRef.current.autoplay?.start();
      }, 1000);
    }
  }, [props.adData]);
  console.log("ad", props.adData);

  return (
    <>
      {/* {openTrendsJsx} */}
      {!props?.gridMode && (
        <div className="bhp-trends-container">
          <Swiper
            // loop={props.adData.length > Math.round(screenWidth / 250)}
            effect={isMobile ? "coverflow" : "slide"}
            autoplay={{
              delay: 2500,
              disableOnInteraction: true,
            }}
            grabCursor={true}
            spaceBetween={isMobile ? 0 : 25}
            centeredSlides={isMobile}
            slidesPerView={"auto"}
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}
            // onSlideChange={() => console.log("slide change")}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            modules={[Autoplay, EffectCoverflow]}
            style={{ paddingBottom: "15px", marginLeft: !isMobile && "0" }}
          >
            {props.adData.map((el, idx) => {
              return (
                <SwiperSlide
                  key={idx}
                  style={{
                    width: "fit-content",
                    height: "100%",
                  }}
                >
                  <div
                    style={{
                      // flexShrink: "0",
                      // marginRight: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                      height: "100%",
                    }}
                  >
                    <BhpTrendsElement
                      pageId={props.pageId}
                      adData={el}
                      idx={idx}
                      onClick={() => {
                        recordAction({
                          action: userActionsTable.expandDetails,
                          pageId: props.bussinessDetailsDB.id,
                          pageSection: "MAIN",
                          pageType: getPageType(
                            props.bussinessDetailsDB.isMarket,
                            props.bussinessDetailsDB.marketType
                          ),
                          notes: `${el.title}`,
                          popId: el.id,
                          popType: "AD",
                        });
                        props.openTrendsExpand(el.id);
                      }}
                      editMode={props.editMode}
                      advanceCustomization={props.advanceCustomization}
                    />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      )}
      {!!props?.gridMode && (
        <IonGrid>
          <IonRow>
            {props.adData.map((el, idx) => {
              return (
                <IonCol
                  size={isMobile ? "7.05" : "4.8"}
                  offset={isMobile ? "2.5" : "0.75"}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                      height: "100%",
                      paddingBottom: "20px",
                    }}
                  >
                    <BhpTrendsElement
                      adData={el}
                      idx={idx}
                      onClick={() => {
                        props.openTrendsExpand(el.id);
                      }}
                      editMode={props.editMode}
                      advanceCustomization={props.advanceCustomization}
                    />
                  </div>
                </IonCol>
              );
            })}
          </IonRow>
        </IonGrid>
      )}
    </>
  );
};

export default BhpTrendsSection;
